'use strict';

const Mn = require('backbone.marionette');
const AppTabView = require('balus/ui/view/body/group/app-tab');
const CoverTemplate = require('balus/ui/template/body/group/cover.hbs');

module.exports = Mn.View.extend({
    template: CoverTemplate,
    modelEvents: {
        'change': 'render'
    },
    regions: {
        'appTab': '.app-tab-wrapper'
    },

    onRender: function() {
        this.showChildView('appTab', new AppTabView({
            model: this.model,
            group: this.getOption('group'),
            roles: this.getOption('roles'),
            hideNavToggle: this.getOption('hideNavToggle')
        }));
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/cover.js